import {
  FeatureFlagsConstants,
  featureFlagsConfig,
} from "./featureFlags.config";

export const isFeatureFlagEnabled = (flag: FeatureFlagsConstants) => {
  if (process.env.SITE_ENV === "local") {
    const isFeatureEnabledLocally = (process.env.LOCALLY_ENABLED_FEATURES || "")
      .split(",")
      .includes(flag);

    return isFeatureEnabledLocally || featureFlagsConfig[flag];
  }

  return featureFlagsConfig[flag];
};

/**
 * @deprecated use isFeatureFlagEnabled("NEW_LEFTBAR_DESIGN") instead
 */
export const getIsNewLeftbarDesign = () =>
  isFeatureFlagEnabled("NEW_LEFTBAR_DESIGN");
